import React from 'react';
import './Title.css';

function Title(props) {
    return (
        <div className="Title">
        {
           !props.link ?
            <h1>{props.value}</h1>
            :
            <h1><a href={props.link}>{props.value}</a></h1>
        }
        </div>
    )
}

export default Title;